import { value as value_7, map, defaultArg } from "./fable_modules/fable-library-js.4.19.0/Option.js";
import { ofArray, singleton, contains, tryFind } from "./fable_modules/fable-library-js.4.19.0/List.js";
import { stringHash } from "./fable_modules/fable-library-js.4.19.0/Util.js";
import { startpageByRole } from "./Kundenportal.MenuDef.fs.js";
import { Page } from "./WebParts/Profile/Types.fs.js";
import { tryFind as tryFind_1 } from "./fable_modules/fable-library-js.4.19.0/Map.js";
import { disableChatWidget, enableChatWidget } from "./ChatWidget.fs.js";
import { update as update_1, parseUrl, init as init_1 } from "../Bfs.Web.Portale/MainDispatch.fs.js";
import { Page as Page_1 } from "./WebParts/StaticPages/Types.fs.js";
import { Page as Page_2 } from "./WebParts/Sepa/Types.fs.js";
import { Page as Page_3 } from "./WebParts/Password/Types.fs.js";
import { Page as Page_4 } from "./WebParts/Login/Types.fs.js";
import { GlobalMsg, Msg, Model } from "../Bfs.Web.Portale/Types.fs.js";
import { Cmd_none, Cmd_OfPromise_either, Cmd_map, Cmd_batch } from "./fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Http_postLogoff } from "./WebParts/Login/State.fs.js";
import { FSharpResult$2 } from "./fable_modules/fable-library-js.4.19.0/Result.js";

export function defaultPageForUser(userRoles) {
    return defaultArg(map((tupledArg_1) => tupledArg_1[1], tryFind((tupledArg) => contains(tupledArg[0], userRoles, {
        Equals: (x, y) => (x === y),
        GetHashCode: stringHash,
    }), startpageByRole)), new Page());
}

export function handleChatWidget(usersession) {
    const kundennummer = tryFind_1("Kundennummer", usersession.SessionData);
    const userId = defaultArg(tryFind_1("UserId", usersession.SessionData), "");
    const firstName = defaultArg(tryFind_1("FirstName", usersession.SessionData), "");
    const lastName = defaultArg(tryFind_1("LastName", usersession.SessionData), "");
    const chatHash = defaultArg(tryFind_1("SprinklrChatHash", usersession.SessionData), "");
    const sprinklrAppId = defaultArg(tryFind_1("SprinklrAppId", usersession.SessionData), "");
    const isChatVisible = defaultArg(map((x) => (x === "true"), tryFind_1("IsChatVisible", usersession.SessionData)), false);
    if (contains("Chat", usersession.Roles, {
        Equals: (x_1, y) => (x_1 === y),
        GetHashCode: stringHash,
    }) && isChatVisible) {
        enableChatWidget(userId, firstName, lastName, usersession.Email, chatHash, kundennummer, sprinklrAppId);
    }
    else {
        disableChatWidget();
    }
}

export function init() {
    let matchValue, page_3, page_4, page_5;
    const initialUrl = window.location.hash;
    return init_1((matchValue = parseUrl(initialUrl), (matchValue != null) ? ((value_7(matchValue) instanceof Page_1) ? ((page_3 = value_7(matchValue), page_3)) : ((value_7(matchValue) instanceof Page_2) ? ((page_4 = value_7(matchValue), page_4)) : ((value_7(matchValue) instanceof Page_3) ? ((page_5 = value_7(matchValue), page_5)) : (new Page_4(initialUrl))))) : (new Page_4(initialUrl))));
}

export function update(msg, model) {
    let msg_1, page;
    let matchResult, url, usersession, userSession;
    switch (msg.tag) {
        case 0: {
            switch (msg.fields[0].tag) {
                case 0: {
                    matchResult = 0;
                    url = msg.fields[0].fields[1];
                    usersession = msg.fields[0].fields[0];
                    break;
                }
                case 1: {
                    matchResult = 1;
                    break;
                }
                case 2: {
                    matchResult = 2;
                    break;
                }
                default:
                    matchResult = 5;
            }
            break;
        }
        case 4: {
            matchResult = 3;
            break;
        }
        case 7: {
            matchResult = 4;
            userSession = msg.fields[0];
            break;
        }
        default:
            matchResult = 5;
    }
    switch (matchResult) {
        case 0:
            return [new Model(model.Page, model.PageModel, usersession, model.VideoOverlayVimeoId, model.MessageBox, model.IsBurgerMenuOpen, model.IsNotificationMenuOpen), Cmd_batch(ofArray([(msg_1 = (new Msg(3, [(url != null) ? ((page = parseUrl(url), (page == null) ? defaultPageForUser(usersession.Roles) : value_7(page))) : defaultPageForUser(usersession.Roles)])), singleton((dispatch) => {
                dispatch(msg_1);
            })), singleton((dispatch_1) => {
                dispatch_1(new Msg(7, [usersession]));
            })]))];
        case 1:
            return [model, Cmd_map((Item_3) => (new Msg(0, [Item_3])), Cmd_OfPromise_either(Http_postLogoff, undefined, (arg) => (new GlobalMsg(2, [new FSharpResult$2(0, [arg])])), (arg_1) => (new GlobalMsg(2, [new FSharpResult$2(1, [arg_1])]))))];
        case 2: {
            const model_2 = new Model(model.Page, model.PageModel, undefined, model.VideoOverlayVimeoId, model.MessageBox, model.IsBurgerMenuOpen, model.IsNotificationMenuOpen);
            disableChatWidget();
            return [model_2, singleton((dispatch_2) => {
                dispatch_2(new Msg(3, [new Page_4(undefined)]));
            })];
        }
        case 3: {
            let msg_7;
            const matchValue = model.User;
            msg_7 = ((matchValue != null) ? (new Msg(3, [defaultPageForUser(matchValue.Roles)])) : (new Msg(3, [new Page_4(undefined)])));
            return [model, singleton((dispatch_3) => {
                dispatch_3(msg_7);
            })];
        }
        case 4: {
            handleChatWidget(userSession);
            return [model, Cmd_none()];
        }
        default:
            return update_1(msg, model);
    }
}

//# sourceMappingURL=Kundenportal.MainDispatch.fs.js.map
